import { render, staticRenderFns } from "./TicketLink.vue?vue&type=template&id=92b9063a&"
import script from "./TicketLink.vue?vue&type=script&lang=js&"
export * from "./TicketLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports